var _style, _ellipse, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _g2, _path9, _path10, _circle6, _path11, _path12, _g3, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Capa_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 500 500"
    },
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{opacity:.05;fill:#020203}.st2{fill:#523d27}.st3{fill:#fddcbf}.st4{fill:#f5f5f5}.st5{opacity:.05}.st6{fill:#020203}.st8{fill:#d66638}.st9{fill:#cc6135}")), /*#__PURE__*/React.createElement("circle", {
    cx: 249.788,
    cy: 248.909,
    r: 222.786,
    style: {
      fill: "#a0b61d"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.127,
    cy: 366.737,
    className: "st1",
    rx: 160.113,
    ry: 10.441
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.9 356.316c-11.666-12.452-19.735-.497-19.735-.497l-14.69-63.429c-46.191 12.494-70.28 29.552-70.28 29.552l-2.58 40.36s-6.73-6.042-14.51-.91c-10.404 6.864 19.125 7.924 19.125 7.924l7.201-41.216c37.23-8.095 54.08-18.83 54.08-18.83l18.333 53.321s31.353 2.579 23.056-6.275z",
    className: "st2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.908 237.337s-23.557-90.834-81.728-36.521c0 0-15.842 23.902.288 68.727 71.992-11.4 81.44-32.206 81.44-32.206z",
    className: "st3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.974 148.783s20.26 56.51-53.045 65.537l1.693 18.07s-9.818-4.051-9.094 4.701c.723 8.756 9.333 1.743 9.333 1.743s-1.431 21.777-9.393 30.709c.584.532-55.08-74.06-13.47-78.145 0 0-.561-17.624 21.544-26.623 22.911-9.327 42.607 15.922 52.432-15.992z",
    className: "st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m194.908 237.337 16.566 55.053s-25.204 17.736-70.279 29.552l-27.727-52.4s57.464-12.623 81.44-32.205z",
    className: "st4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.911 353.007a106.357 106.357 0 0 0 14.803 8.841c3.344-.935 4.923-2.611 2.186-5.532-7.605-8.117-13.68-5.863-16.989-3.31zM224.8 349.92l-13.326-57.53-16.566-55.053s-1.06-4.087-3.285-10.008c-4.762 12.079-7.378 25.238-7.378 39.01 0 17.098 4.04 33.252 11.207 47.567 6.123-2.766 9.06-4.635 9.06-4.635l11.212 32.612c2.87 2.846 5.898 5.53 9.075 8.037z",
    className: "st6"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m177.459 255.523 2.833 2.623-1.101 4.614 9.379 30.364-7.451 11.187-10.661-8.704 4.131-30.817-4.198-3.018.572-3.143zM167.323 214.614c1.226 3.044 3.392 5.042 4.838 4.466 1.447-.578 1.626-3.515.4-6.558-1.228-3.045-3.395-5.043-4.838-4.466-1.448.577-1.625 3.514-.4 6.558zM132.164 230.108c1.224 3.044 3.388 5.045 4.837 4.466 1.441-.579 1.623-3.517.393-6.559-1.224-3.044-3.389-5.043-4.835-4.465-1.446.578-1.624 3.514-.395 6.558z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.425 228.514c-3.62 1.211-15.011 5.244-22.185 10.283a1.436 1.436 0 0 0-.482 1.734c1.254 2.995 5.767 10.768 17.478 5.71 11.557-4.993 8.473-13.883 6.943-16.99a1.441 1.441 0 0 0-1.754-.737z",
    style: {
      fill: "#ec7d87"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m236.917 342.402-9.638 16.734a6.848 6.848 0 1 0 11.867 6.837l9.636-16.73a103.562 103.562 0 0 1-11.865-6.841zM352.073 342.402a103.585 103.585 0 0 1-11.865 6.84l9.636 16.73a6.846 6.846 0 0 0 9.35 2.517 6.848 6.848 0 0 0 2.517-9.353l-9.638-16.734z",
    className: "st2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m358.44 174.544 18.898-26.99-9.817-6.873-18.908 27.004a103.931 103.931 0 0 1 9.827 6.86zM240.377 167.685 221.47 140.68l-9.818 6.873 18.9 26.99a103.886 103.886 0 0 1 9.826-6.86zM289.36 121.645h10.272v71.335H289.36z",
    className: "st4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M305.393 126.781h-21.796a5.136 5.136 0 1 1 0-10.272h21.796a5.136 5.136 0 1 1 0 10.272z",
    className: "st4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 390.641,
    cy: 118.108,
    r: 10.304,
    className: "st4",
    transform: "rotate(-55 390.617 118.103)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.349,
    cy: 118.108,
    r: 10.304,
    className: "st4",
    transform: "rotate(-35 198.341 118.103)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.495,
    cy: 256.153,
    r: 106.402,
    className: "st8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.495,
    cy: 256.153,
    r: 98.749,
    className: "st9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.495,
    cy: 256.153,
    r: 80.075,
    className: "st4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.495 183.025c43.06 0 78.167 33.99 79.987 76.601.05-1.153.088-2.308.088-3.473 0-44.225-35.85-80.075-80.075-80.075-44.224 0-80.075 35.85-80.075 80.075 0 1.165.038 2.32.088 3.473 1.82-42.61 36.928-76.601 79.987-76.601z",
    className: "st6"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M294.495 258.72a2.568 2.568 0 0 1-2.568-2.568v-62.277a2.568 2.568 0 0 1 5.136 0v62.277a2.568 2.568 0 0 1-2.567 2.568z",
    className: "st2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.116 285.669a5.135 5.135 0 0 1-3.631-8.767l24.38-24.38a5.136 5.136 0 1 1 7.262 7.262l-24.38 24.38a5.12 5.12 0 0 1-3.631 1.505z",
    className: "st2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.495,
    cy: 256.152,
    r: 9.178,
    className: "st9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M386.173 124.49c-20.46-14.326-48.224-10.44-64.043 8.264-1.544 1.825-1.132 4.603.826 5.973l71.46 50.037c1.957 1.37 4.708.808 5.895-1.267 12.166-21.262 6.322-48.68-14.138-63.007zM202.817 124.49c-20.46 14.326-26.304 41.745-14.139 63.007 1.187 2.075 3.939 2.638 5.896 1.267l71.46-50.037c1.958-1.37 2.37-4.148.826-5.973-15.82-18.704-43.583-22.59-64.043-8.264z",
    className: "st9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M266.86 132.754c-15.82-18.704-43.583-22.59-64.043-8.264l34.41 34.41 28.807-20.173c1.958-1.37 2.37-4.148.826-5.973zM322.13 132.754c-1.544 1.825-1.132 4.603.826 5.974l28.808 20.17 34.409-34.408c-20.46-14.326-48.224-10.44-64.043 8.264z",
    className: "st8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.36 126.781h10.272v3.857H289.36z",
    className: "st6"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M231.462 273.46c-.636-.495-1.284-.305-1.927.144.551-.663.982-1.77.295-2.296-.523-.409-1.593-.2-2.086.31.491-.659.748-2.043.18-2.488-.638-.498-1.865-.4-2.51.043.715-.913 7.258-6.97 5.902-8.054-1.357-1.084-9.007 7.301-10.248 8.644-1.241 1.343-27.785 33.46-80.005 8.718-4.93-2.133-8.032-3.868-13.496-7.756l-3.162 10.342c4.336 3.033 8.49 5.284 12.465 6.892 57.55 26.488 90.472-8.683 91.96-9.978 1.488-1.294 3.968-3.486 2.632-4.52z",
    className: "st1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.44 271.543c1.406-1.383 3.745-3.724 2.348-4.675-.665-.455-1.3-.225-1.914.263.51-.697.871-1.827.153-2.31-.603-.414-1.832-.041-2.191.609.541-.595.802-2.22.154-2.666-.668-.457-1.887-.285-2.503.199.657-.956 6.815-7.405 5.394-8.403-1.42-.998-8.539 7.843-9.695 9.26-1.156 1.416-25.667 35.11-79.314 13.638l-3.6 9.72c59.075 22.885 89.763-14.251 91.169-15.635z",
    className: "st3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.406 281.068c4.514 2.76 8.798 4.749 12.866 6.109l3.6-9.719c-5.052-1.824-8.256-3.365-13.95-6.908l-2.516 10.518z",
    className: "st4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.d9336e225d3c73309bb17cfdc20ad89e.svg";
export { ForwardRef as ReactComponent };